import { SvgIcon, tw } from "@sveabank/cc-common";

type Props = {
	buttonLabel: string;
	hasWarning?: boolean;
};

const NavButton = ({ buttonLabel, hasWarning }: Props) => (
	<div className="border-background-primary z-30 border-x-[5px] border-y-2 bg-white">
		<button
			type="button"
			className={tw(
				"rounded-large border-interactive-primary text-interactive-primary z-30 flex flex-row items-center gap-2 border-2 px-4 py-2 text-sm font-bold",
				hasWarning && "py-[6px]",
			)}
		>
			{hasWarning && (
				<SvgIcon height={24} imageSrc="ALERT_FILLED" className="text-foreground-alert" />
			)}
			{buttonLabel}
		</button>
	</div>
);

export default NavButton;
